import ConversationActionTypes from '../types/conversation';

const ConversationsReducer = function(/*state, action*/) {
  var defaultState = { pageInfo: {}, edges: [] };
  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
  var action = arguments[1];
  var store = Object.assign(defaultState, state);

  switch (action.type) {
    case ConversationActionTypes.REORDER:
      reorderConversation(action.conversation, store);

      return store;
    case ConversationActionTypes.REPLACE:
      replaceConversation(action.conversation, store);

      return store;
    case ConversationActionTypes.RECEIVE_NEW_PAGE:
      addNewPage(action.conversations, store);

      return store;
    case ConversationActionTypes.REMOVE:
      removeConversation(action.conversation, store);

      return store;
  }

  return state;
};

function reorderConversation (conversation, store) {
  var newEdges = [conversation];
  var conversationFound = false;

  store.edges.forEach(edge => {
    if (edge.node.id === conversation.node.id) {
      conversationFound = true;
    } else {
      newEdges.push(edge);
    }
  });

  if (!conversationFound && store.pageInfo.hasNextPage) {
    newEdges.pop();
  }

  store.edges = newEdges;
}

function replaceConversation (conversation, store) {
  store.edges = store.edges.slice();
  for (var i = 0; i < store.edges.length; i++) {
    if (store.edges[i].node.id === conversation.node.id) {
      store.edges[i] = conversation;
      return;
    }
  }
}

function addNewPage (conversations, store) {
  store.pageInfo = conversations.pageInfo;
  store.edges = store.edges.concat(conversations.edges);
}

function removeConversation (conversation, store) {
  var newEdges = [];

  store.edges.forEach(edge => {
    if (edge.node.id !== conversation.id) {
      newEdges.push(edge);
    }
  });

  store.edges = newEdges;
}

export default ConversationsReducer;
